<template>
  <base-container :isLoading="isLoading">
    <div class="artisan-container">
      <h2 class="artisan-center">绑定水费户号</h2>
      <WaterFee @water-confirm="waterConfirm"></WaterFee>
      <van-button class="artisan-btn" round type="info" block @click="bind">绑定水费户号</van-button>
    </div>
  </base-container>
</template>

<script>
import WaterFee from "../waterfee/Waterfee";
import { Dialog, Toast } from "vant";
import { bindWater } from "@/api/customer";
export default {
  components: {
    WaterFee,
  },
  data() {
    return {
      isLoading: false,
      info: {},
    };
  },
  methods: {
    waterConfirm(info) {
      this.info = info;
    },
    bind() {
      if (this.info.waterNo) {
        Dialog.confirm({
          title: "提示",
          message: "确认绑定水费户号？",
        }).then(() => {
          let data = {
            waterNo: this.info.waterNo,
            groupName: this.info.groupName,
          };
          this.isLoading = true;
          bindWater(data)
            .then(() => {
              this.isLoading = false;
              Toast.success("绑定水费户号成功！");
            })
            .catch(() => {
              this.isLoading = false;
              Toast.fail("绑定水费户号失败！");
            });
        });
      } else {
        Toast.fail("请填写客户代码！");
      }
    },
  },
};
</script>

<style>
</style>